import BaseModelAPI from '../BaseModelAPI';

export default class DivisionList extends BaseModelAPI {

	static entity = 'divisionlist'
	static entityName = 'division';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
